/**
 * Куда вернуть пользователя после входа.
 *
 * ProtectedRoute кладёт исходный адрес в `location.state.from`, но вход через
 * Google уводит со страницы, и state теряется. Поэтому адрес дублируем в
 * sessionStorage: GoogleCallbackPage забирает его оттуда.
 *
 * Только пути внутри приложения: `/…`, но не `//host` — иначе это был бы
 * открытый редирект.
 */
const KEY = 'doit:return-to';

type From = { pathname?: string; search?: string; hash?: string } | undefined;

const isInternal = (path: string) =>
  path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');

export function returnPathFrom(from: From): string {
  if (!from?.pathname) {
    return '/';
  }
  const path = `${from.pathname}${from.search ?? ''}${from.hash ?? ''}`;
  return isInternal(path) ? path : '/';
}

export function rememberReturnTo(path: string) {
  if (path === '/' || !isInternal(path)) {
    return;
  }
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Приватный режим — после Google вернёмся на главную.
  }
}

export function takeReturnTo(): string {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && isInternal(path) ? path : '/';
  } catch {
    return '/';
  }
}
